import IndexTable from './IndexTable';

export default IndexTable;
